import axios from "axios";
import { config } from "dotenv";

config()

const mode ={
    mode: 'no-cors'
}

export const sendMoney = async (userId, receiverId, amount) => {
    try {
        let url = `${process.env.REACT_APP_API_URL}/pouchTransfer/?amount=${amount}&userId=${userId}&receiverId=${receiverId}`
        let response = (await axios.get(url, mode)).data
        // console.log(response)
        return response
    } catch (err) {
        return {
            message: err.message, status: false, code: 400
        }
    }
}